export default "__VITE_ASSET__DInE9$DX__"